import { render, staticRenderFns } from "./reviewer_drawer.vue.js?vue&type=template&id=5660a81c&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviewer_drawer.vue?vue&type=template&id=5660a81c&vue3"
import script from "./reviewer_drawer.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviewer_drawer.vue?vue&type=script&lang=js&vue3"
export * from "./reviewer_drawer.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./reviewer_drawer.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports